import { useQuery } from '@tanstack/react-query';
import { REFERENCE_DATA_KEY } from 'src/utils/constants/queryKeys';
import { getReferenceData } from '../services/fn-api/ReferenceData';

export const useGetReferenceData = (type: string) => {
  return useQuery({
    queryKey: [REFERENCE_DATA_KEY, type],
    queryFn: () => getReferenceData(type),
    enabled: !!type,
  });
};
